export function getFullPermutation(inputs) {
    if (inputs.length === 0) {
        return [[]];
    }
    else {
        const [first, ...rest] = inputs;
        const restFullPermutation = getFullPermutation(rest);
        return first.flatMap(v => restFullPermutation.map(p => [v, ...p]));
    }
}
